import type React from 'react';

type Props = {
	mode: string;
};

export const AvailablePeriodType: React.FC<Props> = ({ mode }) => {
	const types: { [x: string]: string } = {
		ON: 'Онлайн',
		OF: 'Личный приём',
	};
	return <>{types[mode]}</>;
};
